import { render, staticRenderFns } from "./quickmenuContacts.vue?vue&type=template&id=29e4d860&scoped=true&lang=pug&"
import script from "./quickmenuContacts.vue?vue&type=script&lang=js&"
export * from "./quickmenuContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e4d860",
  null
  
)

export default component.exports